import React from "react";

function StoryPictures() {
  return (
  <div className="story__pictures">
    <img src="./img/girl.jpg" alt="girl" class="story__pictures__img--1" />
    <img src="./img/arid-bro.jpg" alt="bro" class="story__pictures__img--2" />
    <img src="./img/couple.jpg" alt="dude" class="story__pictures__img--3" />
  </div>
  );
}

export default StoryPictures;